// extracted by mini-css-extract-plugin
export var dark = "page-header-integration-module--dark--7e7d2";
export var dotsHeaderImgWrapper = "page-header-integration-module--dotsHeaderImgWrapper--a65d8";
export var dotsHeaderWrapper = "page-header-integration-module--dotsHeaderWrapper--e4473";
export var headerInfo = "page-header-integration-module--headerInfo--9d40c";
export var hugeTitle = "page-header-integration-module--hugeTitle--c67e5";
export var image = "page-header-integration-module--image--87f85";
export var item = "page-header-integration-module--item--dadb9";
export var meta = "page-header-integration-module--meta--4e34f";
export var pricingPage = "page-header-integration-module--pricingPage--95a8b";
export var root = "page-header-integration-module--root--631e8";
export var subscription = "page-header-integration-module--subscription--13d07";
export var subscriptionContainer = "page-header-integration-module--subscriptionContainer--46471";
export var subtitle = "page-header-integration-module--subtitle--865ad";
export var title = "page-header-integration-module--title--da2f9";